<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">批条酒下单</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="pageMode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY006', 'WLYALL']) && !conditions.OBJECT_ID">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
        </template>
        <template v-if="conditions.OBJECT_ID">
          <template v-if="conditions.STATUS === 'E0004' && conditions.change">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>

          <template v-else-if="conditions.STATUS !== 'E0003' && $_has(['WLY006', 'WLYALL'])">
            <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
          </template>

          <template v-else-if="conditions.STATUS !== 'E0006' && $_has(['WLY006', 'WLYALL']) && !showEdit">
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template v-if="conditions.STATUS !== 'E0006' && $_has(['WLY006', 'WLYALL', 'WLY002']) && !showEdit">
            <form-button @click="orderlock('UNLOCK')">订单解锁</form-button>
          </template>
        </template>

        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="orderDisplay">显示</form-button>
          <template v-if="$_has(['WLY006', 'WLYALL'])">
            <template v-if="conditions.STATUS === 'E0002' || conditions.STATUS === 'E0005'">
              <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
              <form-button icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
            <template v-if="conditions.STATUS === 'E0003'">
              <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
              <form-button @click="changeStatus('REJECT')">审核拒绝</form-button>
              <form-button @click="changeStatus('CANCEL')">取消</form-button>
            </template>
          </template>

          <template v-if="conditions.STATUS === 'E0004' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>

        </template>

      </div>
      <el-form
        ref="form"
        inline
        :show-message="false"
        size="mini"
        :model="conditions"
        :rules="rules"
        :disabled="isEdit"
        label-width="100px"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input
                :value="conditions.OBJECT_ID"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select
                :value="conditions.PROCESS_TYPE"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                :value="conditions.CUST_NAME"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <wly-input
                v-model="conditions.CUSTOMER"
                clearable
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog('client')"
              />
              <!-- <el-input
                v-model="conditions.CUSTOMER"
                placeholder=""
                type="text"
                clearable
                @focus="openSelectDialog('client')"
              /> -->
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00002J" label="客户性质">
              <el-select v-model="conditions.ZZFLD00002J" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0004']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.CUSTOMER_TYPE" clearable placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00002K" label="发货类型">
              <el-select v-model="conditions.ZZFLD00002K" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0005']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00002L" label="联系人">
              <el-input
                v-model="conditions.ZZFLD00002L"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00002M" label="联系电话">
              <el-input
                v-model="conditions.ZZFLD00002M"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.ZCUSTOM_NAME" placeholder="" clearable :disabled="isEdit" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="isOldOrder">
          <el-col :lg="8" :md="12">
            <el-form-item prop="REGION" label="省">
              <el-select v-model="conditions.REGION" @change="changeArea($event, 'city')">
                <el-option
                  v-for="item in selectDataOptions['regionList']"
                  :key="item.BLAND"
                  :value="item.BLAND"
                  :label="item.BEZEI"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="CITY_CODE" label="市">
              <el-select v-model="conditions.CITY_CODE" @change="changeArea($event, 'street')">
                <el-option
                  v-for="item in selectDataOptions['cityList']"
                  :key="item.CITY_CODE"
                  :value="item.CITY_CODE"
                  :label="item.CITY_NAME"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="STREET_CODE" label="区">
              <el-select v-model="conditions.STREET_CODE" @change="changeArea($event, 'q')">
                <el-option
                  v-for="item in selectDataOptions['streetList']"
                  :key="item.STRT_CODE"
                  :value="item.STRT_CODE"
                  :label="item.MC_STREET"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item v-if="isOldOrder" prop="STREET" label="详细地址">
              <el-input
                v-model="conditions.STREET"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
            <el-form-item v-else label="收货地址">
              <el-input
                v-model="conditions.ZZFLD00002N"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                :disabled="conditions.STATUS !== 'E0003'"
                placeholder=""
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="ZZFLD000001">
              <el-input v-model="conditions.ZZFLD000001_TEXT" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input
                :value="conditions.ZZFLD00003E"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input
                :value="conditions.ZZFLD000002_TEXT"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input
                :value="conditions.ZZFLD000003_TEXT"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                :value="conditions.ZZFLD000004_DSCR"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                placeholder=""
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                :value="conditions.ZZFLD00002D_DSCR"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                :value="conditions.POSTING_DATE"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                :value="conditions.STATUS"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售订单行项目" :custome-config="() => vxeShowCustom('orderDetail')">
        <template #button>
          <table-button name="save" :disabled="isEdit" tip="保存" @click="updateSaleItem" />
          <table-button name="add" :disabled="isEdit" tip="新增" @click="tableEvent('add')" />
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="orderDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #ORDERED_PROD="{row}">
            <wly-input
              v-model="row.ORDERED_PROD"
              size="mini"
              :disabled="isEdit"
              input-type="salesProduct"
              :sales-query-params="productParams"
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="openSelectDialog('product', row)"
            />
          </template>
          <template #REWARD_TYPE="{row,rowIndex}">
            <el-select
              v-model="row.REWARD_TYPE"
              size="mini"
              placeholder=""
              clearable
              @change='changeType($event,rowIndex)'
            >
              <el-option
                v-for="item2 in selectDataOptions['A0077']"
                :key="item2.value"
                :label="item2.name"
                :value="item2.value"
              />
            </el-select>
          </template>
          <template #REWARD_NUMBER="{row}">
            <el-input
              v-model="row.REWARD_NUMBER"
              :disabled="isEdit || !row.REWARD_TYPE"
              size="mini"
              @focus="openSelectDialog('reward', row)"
            />
          </template>
          <template #ZZFLD00002U="{row}">
            <el-input
              v-model.number="row.ZZFLD00002U"
              size="mini"
              :disabled="isEdit"
              @keyup.enter.native="updateSaleItem"
              @input="changePrice($event, 'ZZFLD00002U', row)"
            />
          </template>
          <template #ZZFLD000009="{row}">
            <el-input
              v-model="row.ZZFLD000009"
              size="mini"
              type="number"
              :disabled="isEdit"
              @keyup.enter.native="updateSaleItem"
              @input="changePrice($event, 'ZZFLD000009', row)"
            />
          </template>
          <template #NET_PRICE="{row}">
            <el-input
              v-model="row.NET_PRICE"
              size="mini"
              type="number"
              :disabled="isEdit"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              size="mini"
              :disabled="isEdit"
              placeholder=""
            >
              <el-option
                v-for="item in selectDataOptions['A0037']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input
              v-model="row.ZZFLD00002I"
              type="number"
              size="mini"
              :disabled="isEdit"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox
              v-model="row.ZZFLD00002B"
              true-label="X"
              false-label=""
              disabled
            >是</el-checkbox>
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              size="mini"
              :disabled="isEdit"
            />
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="剩余现金奖励" :custome-config="() => vxeShowCustom('fileTable')" v-if="role.ROLE == 'WLY002' || role.ROLE == 'WLYALL'">
        <template #button>
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsCash.columns"
          :data="gridOptionsCash.data"
        >
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            accept=".png,.pdf,.jpg"
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <!-- <template #toolbar /> -->
          <template #FILENAME="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('historyTable')">
        <vxe-grid
          ref="historyTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <cashRewards v-if="showDialogType === 'reward'" :head='conditions' :item=currentData :allData="gridOptions.data" ref="dialogEdit"/>
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <sale-product-select
          v-if="showDialogType === 'product'"
          ref="dialogEdit"
          :info="productParams"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { mapGetters } from 'vuex'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiPTaUpdateSaleItem, apiPTSave, getOrderDetail } from '@/api/sap/order-sap'
import { apiSapSingleClientInfo, apiOrderLock } from '@/api/common'
import { getArea } from '@/api/sap/common-sap'

import { sapDownloadFile } from '@/utils/frontExport'
const SaleProductSelect = () => import('@/components/dialog/SaleProductSelect.vue')
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const cashRewards = () => import('@/views/reward-policy/components/cashRewards.vue')

export default {
  components: {
    SaleProductSelect,
    ClientSelect,
    cashRewards
  },
  data() {
    const rules = {
      CUSTOMER: [{ required: true, message: '请选择客户', trigger: 'change' }],
      ZZFLD00002J: [{ required: true, message: '请选择客户性质', trigger: 'blur' }],
      ZZFLD00002M: [{ required: true, message: '请选择联系电话', trigger: 'blur' }],
      ZZFLD00002K: [{ required: true, message: '请选择发货类型', trigger: 'blur' }],
      STREET: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
      REGION: [{ required: true, message: '请选择省', trigger: 'blur' }],
      CITY_CODE: [{ required: true, message: '请选择市', trigger: 'blur' }],
      STREET_CODE: [{ required: true, message: '请选择区', trigger: 'blur' }],
      // ZZFLD00002N: [{ required: true, message: '请选择收货地址', trigger: 'blur' }],
      ZZFLD00002L: [{ required: true, message: '请选择联系人', trigger: 'blur' }],
      ZZFLD000001: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
    }
    return {
      rules,
      showEdit: false,
      pageMode: 'add',
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      currentData: {},
      errorList: [],
      selectDataOptions: {
        cityList: [],
        streetList: [],
        regionList: []
      },
      productParams: {
        PROCESS_TYPE: 'ZS03',
        CUSTOMER: '',
        mode: 'PT'
      },
      conditions: {
        OBJECT_ID: '', // 订单编号
        PROCESS_TYPE: 'ZS03', // 订单类型
        POSTING_DATE: '', // 创建日期
        CUSTOMER: '', // 客户编号
        CUST_NAME: '', // 客户名称
        CUSTOMER_TYPE: '', // 客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建账号
        ZZFLD00002D_DSCR: '', // 描述
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD000001_TEXT: '', // 营销单元
        ZZFLD00003E: '', // 基地
        ZCUSTOM_NAME: '',
        ZZFLD000002: '', // 省
        ZZFLD000002_TEXT: '', // 省
        ZZFLD000003: '', // 市
        ZZFLD000003_TEXT: '', // 市
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员
        ZZFLD00002J: '', // 客户性质
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系人电话
        ZZFLD00008T: '', // 收货方
        ZZFLD00002N: '', // 收货地址
        ZZFLD00003C: 'WEB',
        REGION: '',
        REGION_TEXT: '',
        CITY_CODE: '',
        CITY_TEXT: '',
        STREET_CODE: '',
        STREET_TEXT: '',
        STREET: ''
      },
      loading: false,
      gridOptions: {
        columns: [
          { filed: 'checkbox', type: 'checkbox', title: '', width: 40 },
          {
            field: 'NUMBER_INT',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 180,
            slots: { default: 'ORDERED_PROD' },
            params: { bgEdit: true }
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 250
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 180
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80,
            slots: { default: 'ZZFLD00002U' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80
          },
          {
            field: 'NET_PRICE',
            title: '含税单价',
            width: 100,
            slots: { default: 'NET_PRICE' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002Z',
            title: '税价合计',
            width: 100
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        columnsFieldTypes: {
          ORDERED_PROD: 'selectProduct',
          ZZFLD00002A: 'select',
          ZZFLD000009: 'input',
          ZZFLD000008: 'input',
          ZZFLD00002B: 'checkbox',
          NET_PRICE: 'input',
          ZZFLD00002I: 'input',
          ZZFLD00002U: 'input',
          NUMBER_INT: 'NUMBER_INT'
        },
        data: [],
        delData: []
      },
      rewardList: [
        {
          field: 'REWARD_TYPE',
          title: '奖励类型编码',
          width: 100,
          slots: { default: 'REWARD_TYPE' },
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NUMBER',
          title: '奖励/计划编号',
          width: 120,
          slots: { default: 'REWARD_NUMBER' },
          editRender: {},
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NAME',
          title: '项目/计划类型',
          width: 180
        },
      ],
      gridOptionsCash: {
        columns: [
          {
            field: 'REWARD_NUMBER',
            title: '项目奖励编码',
            width: 120
          },
          {
            field: 'REWARD_ID',
            title: '项目类型编码',
            width: 120
          },
          {
            field: 'REWARD_NAME',
            title: '项目类型描述',
            width: 180
          },
          {
            field: 'CUSTOMER',
            title: '项目客户编码',
            width: 120
          },
          {
            field: 'CUSTOMER_NAME',
            title: '项目客户名称',
            width: 180
          },
          {
            field: 'START_DATE',
            title: '有效期起',
          },
          {
            field: 'END_DATE',
            title: '有效期止',
          },
          {
            field: 'QUOTA_RATIO',
            title: '额度比例(%)',
          },
          {
            field: 'AMOUNT',
            title: '项目金额（元）',
          },
          {
            field: 'REMAIN_AMOUNT',
            title: '剩余金额（元）',
          },
        ],
        data: [],
        delData: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          { field: 'FILELENGTH', title: '大小', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'CREATED_DATE', title: '上传日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CREATED_TIME', title: '上传时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: [],
        delData: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '' },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD000031', title: '操作人姓名' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'ZZFLD00000X', title: '变更时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      }
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.OBJECT_ID) {
        return !this.showEdit
      } else {
        return false
      }
    },
    ...mapGetters(['role', 'customerInfo']),
    isOldOrder() {
      return (this.conditions.REGION && this.conditions.CITY_CODE && this.conditions.STREET_CODE) || !this.conditions.OBJECT_ID
    }
  },
  watch: {
    'conditions.CUSTOMER': {
      handler(nv) {
        this.productParams.CUSTOMER = nv
      }
    },
    'gridOptions.data': {
      handler(nv, ol) {
        nv.forEach((item, i) => {
          item.NUMBER_INT = (i + 1) * 10
        })
      },
      deep: true
    }
  },
  created() {
    const pageQuery = this.$route.query
    if (pageQuery?.object_id) {
      this.pageMode = 'edit'
      this.initOrderInfoById(pageQuery.object_id, 1)
    } else {
      if (this.role.ROLE === 'WLY001') {
        this.conditions.CUSTOMER = this.customerInfo.info.partner
        this.conditions.CUSTOMER_TYPE = this.customerInfo.info.zzfld000016
        this.conditions.CUST_NAME = this.customerInfo.info.name_org1
        this.conditions.ZZFLD000001 = this.customerInfo.yxdy[0].zzfld00001h
        this.conditions.ZZFLD000001_TEXT = this.customerInfo.yxdy[0].mc_short
        this.conditions.ZZFLD00003E = this.customerInfo.yxdy[0].mc_short_jd
        this.conditions.ZZFLD000002 = this.customerInfo.info.region
        this.conditions.ZZFLD000002_TEXT = this.customerInfo.info.bezei
        this.conditions.ZZFLD000003 = this.customerInfo.info.city_code
        this.conditions.ZZFLD000003_TEXT = this.customerInfo.info.city_name
        this.conditions.ZZFLD000004 = this.customerInfo.info.sales_emp
        this.conditions.ZZFLD000004_DSCR = this.customerInfo.info.sales_emp_name
        this.productParams.CUSTOMER = this.customerInfo.info.partner
        this.$set(this.selectDataOptions, 'orgList', this.customerInfo.yxdy)
        const reladdress = this.customerInfo.address.find(v => v.adr_kind === 'SHIP_TO')
        this.conditions.ZZFLD00002L = reladdress.c_o_name
        this.conditions.ZZFLD00002M = reladdress.tel_number
        this.conditions.STREET = reladdress.street
      }
      this.conditions.ZZFLD00002D_DSCR = this.role.login_user
      this.conditions.ZZFLD00002D = this.role.USER_BP
      this.conditions.POSTING_DATE = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.tableEvent('add')
    }
    if(this.role.ROLE == 'WLY002' || this.role.ROLE == 'WLYALL'){
      this.gridOptions.columns.splice(2, 0, ...this.rewardList);
    }
    // 初始化省份
    getArea().then(res => {
      this.selectDataOptions['regionList'] = res.DATA
    })
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    // 发货类型
    this.getSelectDictDataOrigin('A0005')
    // 客户性质
    this.getSelectDictDataOrigin('A0004')
    this.getSelectDictDataOrigin('A0009')
    // 奖励政策
    this.getSelectDictDataOrigin('A0077')
  },
  methods: {
    changeType(e,idx){
      if(e == 'V001'){
        this.gridOptions.data[idx].ZZFLD00002A = 'V003'
      }else if(e == 'V002'){
        this.gridOptions.data[idx].ZZFLD00002A = 'V002'
      }else{
        this.gridOptions.data[idx].REWARD_NUMBER = ''
        this.gridOptions.data[idx].REWARD_ID = ''
        this.gridOptions.data[idx].REWARD_NAME = ''
        this.gridOptions.data[idx].ZZFLD00002A = ''
      }
    },
    async changeArea(e, type) {
      if (e) {
        if (type === 'city') {
          const { DATA } = await getArea(e, type)
          this.selectDataOptions.cityList = DATA
          this.conditions.REGION_TEXT = this.selectDataOptions['regionList'].find(v => v.BLAND === e)?.BEZEI
          this.conditions.CITY_CODE = ''
          this.conditions.STREET_CODE = ''
          this.conditions.CITY_TEXT = ''
          this.conditions.STREET_TEXT = ''
          this.selectDataOptions.streetList = []
        } else if (type === 'street') {
          const { DATA } = await getArea(e, type)
          this.selectDataOptions.streetList = DATA
          this.conditions.STREET_CODE = ''
          this.conditions.STREET_TEXT = ''
          this.conditions.CITY_TEXT = this.selectDataOptions['cityList'].find(v => v.CITY_CODE === e)?.CITY_NAME
        } else {
          this.conditions.STREET_TEXT = this.selectDataOptions['streetList'].find(v => v.STRT_CODE === e)?.MC_STREET
        }
      }
    },
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    delUpload() {
      const checkList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkList.length) return this.$message.warning('请选择有效数据！')
      checkList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(checkList.filter(v => v.GUID))
      }
    },
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID, type = 0) {
      this.loading = true
      try {
        const res = await getOrderDetail({ OBJECT_ID })
        if (res?.MSGTYPE === 'S') {
          const { DATA } = res
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.change = res.CHANGE
          this.conditions.cancel = res.CANCEL
          this.gridOptions.data = DATA.ITEM || []
          this.gridOptionsFile.data = DATA.ATTACHMENT || []
          this.gridOptionsHistory.data = DATA.HISTORY || []
          this.gridOptionsCash.data = DATA.CASH || []
          type && this.initCustome()
          this.initAddressInfo()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    async initAddressInfo() {
      if (this.conditions.REGION) {
        const { DATA } = await getArea(this.conditions.REGION, 'city')
        this.selectDataOptions['cityList'] = DATA
      }
      if (this.conditions.CITY_CODE) {
        const { DATA: DATA2 } = await getArea(this.conditions.CITY_CODE, 'street')
        this.selectDataOptions['streetList'] = DATA2
      }
    },
    async orderModify() {
      const res = await this.orderlock('ADD')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = true
    },
    async orderDisplay() {
      const res = await this.orderlock('DELETE')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = false
    },
    // 订单解锁
    async orderlock(mode) {
      this.errorList = []
      const params = {
        type: this.conditions.PROCESS_TYPE,
        number: this.conditions.OBJECT_ID,
        status: mode === 'ADD' ? 1 : 2
      }
      if (mode === 'UNLOCK') {
        await this.$confirm('解锁前请确认当前没有其他人修改此订单！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
      const { data } = await apiOrderLock(params)
      if (data.status && params.status === 1) {
        this.errorList = [data.message]
        return false
      }
      return true
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 保存 提交 确认  新建 E0001,已保存待提交 E0002,已提交待审核 E0003, 审核通过 E0004,审核拒绝 E0005,已取消 E0006
    changeStatus(status) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          // await this.confirmMode(status)
          // apiPTSave
          const params = {
            user_bp: this.role.USER_BP,
            MODE: status,
            info: this.conditions,
            item: this.gridOptions.data.concat(this.gridOptions.delData),
            attachment: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
          }
          // params.info.ZZFLD00002N = this.regionInfo + '-' + this.conditions.ZZFLD00002N
          this.loading = true
          this.errorList = []
          const result = await apiPTSave(params)
          if (result?.MSGTYPE === 'S') {
            this.$message.success(result.MESSAGE)
            this.gridOptionsFile.delData = []
            this.gridOptions.delData = []
            this.conditions.OBJECT_ID = result.DATA.INFO.OBJECT_ID
            this.orderDisplay()
          } else {
            this.errorList.push(result.MESSAGE)
            this.loading = false
            return
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        partner: this.conditions.CUSTOMER,
        user_bp: this.role.USER_BP
      }
      const { data } = await apiSapSingleClientInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data.yxdy)
    },
    changePrice(e, field, row) {
      if (field === 'ZZFLD00002U') {
        // 输入数量， 计算件数
        row.ZZFLD000009 = (e / row.ZZFLD00002W).toFixed(2)
      } else if (field === 'ZZFLD000009') {
        // 输入件数，计算数量
        row.ZZFLD00002U = e * row.ZZFLD00002W
      }
    },
    tableEvent(code) {
      const orderDetailsEmpty = {}
      this.gridOptions.columns.forEach(v => {
        !v.type && (orderDetailsEmpty[v.field] = '')
      })
      switch (code) {
        case 'add':
          // orderDetailsEmpty.NUMBER_INT = (this.gridOptions.data.length + 1) * 10
          this.gridOptions.data.unshift(orderDetailsEmpty)
          break
        case 'del':
          this.delDetail()
          break
      }
    },
    delDetail() {
      const checkList = this.$refs.orderDetail.getCheckboxRecords()
      if (!checkList.length) return this.$message.success('请选择有效数据！')
      checkList.forEach(item => {
        item.MODE = 'D'
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptions.delData = this.gridOptions.delData.concat(checkList.filter(v => v.GUID))
      }
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const dateTime = new Date().getTime()

        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type,
          DOC_TYPE: file.raw.type,
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.ROLE,
          ZZFLD00002D_DSCR: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 下载附件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    },
    // 打开窗口
    openSelectDialog(type, row = {}, mode) {
      this.currentData = row
      this.showDialogType = type
      this.dialogTitle = {
        product: '产品选择',
        client: '客户选择',
        reward: '剩余现金奖励选择',
      }[type]
      this.showDialog = true
    },
    // 选择订单客户
    selectClient(res) {
      this.errorList = []
      // 判断选择的客户是否有 其他销售类型
      const item = res.orgList.find(v => v.mc_short === '其他销售类型')
      if (!item) {
        this.errorList.push(`该客户：${res.partner}没有维护相关营销单元`)
        return
      }
      this.conditions.CUSTOMER = res.partner
      this.conditions.CUSTOMER_TYPE = res.zzfld000016
      this.conditions.CUST_NAME = res.name_org1
      this.conditions.ZZFLD000002 = res.region
      this.conditions.ZZFLD000002_TEXT = res.bezei
      this.conditions.ZZFLD000003 = res.city_code
      this.conditions.ZZFLD000003_TEXT = res.city_name
      this.conditions.ZZFLD000004 = res.sales_emp
      this.conditions.ZZFLD000004_DSCR = res.sales_emp_name
      this.productParams.CUSTOMER = res.partner
      this.conditions.ZZFLD000001 = item?.zzfld00001h || ''
      this.conditions.ZZFLD000001_TEXT = item?.mc_short || ''
      this.conditions.ZZFLD00003E = item?.mc_short_jd || ''
      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsHistory.data = []
      this.gridOptionsFile.data = []
      this.gridOptionsFile.delData = []
      this.tableEvent('add')

      // this.$set(this.selectDataOptions, 'orgList', res.orgList)
    },
    async updateSaleItem() {
      const params = {
        info: this.conditions,
        item: this.gridOptions.data
      }
      this.errorList = []
      const result = await apiPTaUpdateSaleItem(params)
      if (result?.MSGTYPE === 'E') {
        this.errorList.push(result.MESSAGE)
      }
      const { DATA } = result
      Object.assign(this.conditions, DATA.INFO)
      this.gridOptions.data = DATA.ITEM
      this.gridOptionsCash.data = DATA.CASH_REWARD
    },
    selectProduct(res) {
      this.currentData.ORDERED_PROD = res.PRODUCT_ID
      this.currentData.ZZFLD00002T = res.MSEHT
      this.currentData.DESCRIPTION = res.SHORT_TEXT
      this.currentData.ZZFLD00002S = res.NORMS

      this.updateSaleItem()
    },
    selectReward(res){
      this.currentData.REWARD_NUMBER = res.reward_number
      this.currentData.REWARD_ID = res.reward_id
      this.currentData.REWARD_NAME = res.reward_name
      this.updateSaleItem()
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        switch (this.showDialogType) {
          case 'product':
            this.selectProduct(res)
            break
          case 'client':
            this.selectClient(res)
            break
          case 'reward':
            this.selectReward(res)
            break
        }
        this.showDialog = false
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      this.currentData = row

      switch (type) {
        case 'customer':
          this.selectClient(data)
          break
        case 'salesProduct':
          this.selectProduct(data)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/batchTicketOrderEdit.vue